import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const getWorkFlowByIdData = (workflowId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    let newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const workflowIdForUrl = workflowId ? encodeURIComponent(workflowId) : 'NaN';
    const url = `/Workflow/${workflowIdForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  };
};

export default getWorkFlowByIdData;